import React from "react";
import useDraftPicks from "../../hooks/queryResults/draft/useDraftPicks";
import useDraftSettings from "../../hooks/queryResults/draft/useDraftSettings";
import useNflTeams from "../../hooks/queryResults/nfl/useNflTeams";
import useAllPlayers from "../../hooks/queryResults/useAllPlayers";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import breakpoints from "../../style/breakpoints";
import NflUtil from "../../util/nflUtil";
import Util from "../../util/util";
import PlayerImageByPos from "../player/PlayerImageByPos";
import { getPlayerName } from "../player/PlayerName";
import Loading from "../ui/Loading";
import styled from "styled-components";

const StyledContainerDiv = styled.div`
  margin: 1rem 0;
`;

const StyledTable = styled.table`
  width: 100%;

  & td,
  & th {
    padding: 0.25rem;
    height: 28px;
  }

  & th.heading {
    font-size: larger;
    background-color: #0078f8;
    color: white;
  }
`;

export default function TeamPicks({ team }) {
  const { draftPicksData, draftPicksQuery } = useDraftPicks();
  const { draftSettingsData, draftSettingsQuery } = useDraftSettings();
  const { playersData, playersQuery } = useAllPlayers();
  const { nflTeamsData, nflTeamsQuery } = useNflTeams();

  const isLoading = useIsLoading(
    draftPicksData,
    draftPicksQuery,
    draftSettingsData,
    draftSettingsQuery,
    playersData,
    playersQuery,
    nflTeamsData,
    nflTeamsQuery
  );

  if (!team) return null;
  if (isLoading) return <Loading />;

  console.log("team", team);

  const headerRow = (key) => (
    <tr key={key}>
      <th>Rd</th>
      <th>Pk</th>
      <th>&nbsp;</th>
      <th>Pos</th>
      <th>Player</th>
      <th>NFL</th>
      <th>Bye</th>
    </tr>
  );

  return (
    <StyledContainerDiv>
      <StyledTable>
        <thead>
          <tr>
            <th colSpan={7} className={"heading"}>
              Picks
            </th>
          </tr>
          {headerRow("header")}
        </thead>
        <tbody>
          {draftPicksData.picks
            .filter((pick) => pick.team === team.obj.id)
            .map((pick, i) => {
              let player = null;
              let playerName = null;
              let playerImage = null;
              let pos = null;
              let nflTeamAbbr = null;
              let byeWeek = null;

              if (pick.player) {
                player = playersData.players[pick.player];

                if (player.nflTeamAbbr) {
                  nflTeamAbbr = NflUtil.formatNflTeamAbbr(player.nflTeamAbbr);
                  const nflTeam = nflTeamsData.nflTeams[player.nflTeamAbbr];
                  if (nflTeam) byeWeek = nflTeam.byeWeek;
                }

                pos = player.pos;
                playerName = getPlayerName(player, {
                  injury: 1,
                  short: !breakpoints.lg,
                });
                playerImage = (
                  <PlayerImageByPos
                    player={player}
                    isAnimated={false}
                    style={{ maxWidth: "18px" }}
                  />
                );
              }

              const round = Util.getRoundFromPickNum(
                pick.pickNum,
                draftSettingsData.settings.numTeams
              );

              return (
                <React.Fragment key={"fragment" + i}>
                  <tr>
                    <td>{round}</td>
                    <td>{pick.pickNum}</td>
                    <td>{playerImage}</td>
                    <td>{pos}</td>
                    <td style={{ whiteSpace: "nowrap", textAlign: "left" }}>
                      {playerName}
                    </td>
                    <td>{nflTeamAbbr}</td>
                    <td>{byeWeek}</td>
                  </tr>
                </React.Fragment>
              );
            })}
        </tbody>
      </StyledTable>
    </StyledContainerDiv>
  );
}
